// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file custom_group_management/custom_group_management.proto (package custom_group_management, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message custom_group_management.GetCustomerManagedGroupsRequest
 */
export type GetCustomerManagedGroupsRequest = {
}
;
/**
 * @generated from message custom_group_management.GetCustomerManagedGroupsResponse
 */
export type GetCustomerManagedGroupsResponse = {
/**
 * @generated from field: repeated string user_groups = 1;
 */
userGroups?: string[];
}
;
/**
 * @generated from message custom_group_management.CreateUserGroupsRequest
 */
export type CreateUserGroupsRequest = {
/**
 * @generated from field: repeated string group_names = 1;
 */
groupNames?: string[];
/**
 * @generated from field: custom_group_management.UserContext user_context = 2;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message custom_group_management.CreateUserGroupsResponse
 */
export type CreateUserGroupsResponse = {
/**
 * @generated from field: string status_update = 1;
 */
statusUpdate?: string;
}
;
/**
 * @generated from message custom_group_management.RemoveUserGroupsRequest
 */
export type RemoveUserGroupsRequest = {
/**
 * @generated from field: repeated string members = 1;
 */
members?: string[];
/**
 * @generated from field: custom_group_management.UserContext user_context = 2;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message custom_group_management.RemoveUserGroupsResponse
 */
export type RemoveUserGroupsResponse = {
/**
 * @generated from field: string status_update = 1;
 */
statusUpdate?: string;
}
;
/**
 * @generated from message custom_group_management.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc custom_group_management.CustomGroupManagementService.GetCustomerManagedGroups
 */
export const CustomGroupManagementService_GetCustomerManagedGroups = new RPC<GetCustomerManagedGroupsRequest,GetCustomerManagedGroupsResponse>("GET", "/getCustomerManagedGroups");
/**
 * @generated from rpc custom_group_management.CustomGroupManagementService.CreateUserGroups
 */
export const CustomGroupManagementService_CreateUserGroups = new RPC<CreateUserGroupsRequest,CreateUserGroupsResponse>("POST", "/createUserGroups");
/**
 * @generated from rpc custom_group_management.CustomGroupManagementService.RemoveUserGroups
 */
export const CustomGroupManagementService_RemoveUserGroups = new RPC<RemoveUserGroupsRequest,RemoveUserGroupsResponse>("POST", "/removeUserGroups");
